import type { ChangelogEntry } from "../types";

/** VIB-2926: leverandør-ID på bilag, og synken tømmer ikke lenger leverandørfelt. */
export const BILAG_LEVERANDOR_2026_10: ChangelogEntry = {
  id: "2026-10-24-bilag-leverandor",
  date: "2026-10-24",
  title: "Leverandørnavn på bilag forsvinner ikke lenger",
  summary:
    "Bilag-synken kunne tømme leverandørnavn, forfallsdato og PDF-tilgang på bilag som allerede var hentet. Nå oppdateres feltene bare når PowerOffice faktisk sender en verdi, og leverandøren lagres også med PowerOffice sin ID.",
  sections: [
    {
      heading: "Bilag",
      minRole: "user",
      items: [
        {
          title: "Leverandør og PDF blir stående",
          kind: "rettet",
          body: "Før kunne et bilag miste leverandørnavnet, forfallsdatoen eller PDF-knappen når det ble synket på nytt uten nye bilag i samme kjøring. Det skjer ikke lenger.",
        },
        {
          title: "Leverandøren kjennes igjen på ID",
          kind: "nytt",
          body: "Hvert leverandørbilag lagrer PowerOffice sin leverandør-ID, så samme leverandør kan kjennes igjen selv om navnet staves ulikt på forskjellige bilag.",
        },
      ],
    },
  ],
};
